module.exports = __webpack_public_path__ + "static/img/coupon_bg_zh.c94c4d82.png";